document.addEventListener("DOMContentLoaded", () => {
  // 复制文本到剪贴板（兼容旧浏览器）
  function copyToClip2(content) {
    var aux = document.createElement("input");
    aux.setAttribute("value", content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
  }

  // 点击 COPY 按钮复制优惠码，并显示成功反馈
  $(".anniversary-sale-2026 .sale-code-btn").click(function () {
    var $btnText = $(this).find(".sale-code-text");
    var text = $(this).closest(".sale-code-row").find(".sale-code").text().trim();
    copyToClip2(text);
    $btnText.text("✓");
    setTimeout(function () {
      $btnText.text("COPY");
    }, 3000);
  });
});
